const keepQueryParamOnTabChange = (tabnames, param_name)=>{
    /* keep query param on tab change
   */ return (nextRequest, nextQuery, oldRequest)=>{
        let { query: oldQuery } = oldRequest;
        if (nextRequest.id == oldRequest.id && tabnames.includes(nextRequest.tabname)) {
            let oldVal = oldQuery[param_name];
            if (oldVal) {
                return {
                    query: {
                        [param_name]: oldVal,
                        ...nextQuery
                    }
                };
            }
            return {};
        }
    };
};
export const tree = {
    tabs: {
        ftsearch: {
            customizeRouting: keepQueryParamOnTabChange([
                'ftsearch',
                'semsearch'
            ], 'query'),
            acl: 'g:admin',
            datatype: [
                1,
                2,
                0,
                10
            ],
            tabGroup: 'titles',
            parts: [
                'TreeSearchFulltext'
            ],
            order: 98
        },
        semsearch: {
            customizeRouting: keepQueryParamOnTabChange([
                'ftsearch',
                'semsearch'
            ], 'query'),
            acl: 'g:admin',
            datatype: [
                1,
                3,
                10,
                13,
                16,
                19
            ],
            tabGroup: 'titles',
            parts: [
                'TreeSearchSemantic'
            ],
            label: 'Semantisch',
            order: 102
        },
        index: {
            acl: 'g:admin',
            datatype: [
                1,
                2,
                0,
                3,
                13,
                16,
                19,
                10,
                24
            ],
            tabGroup: 'overview',
            minorTabGroup: 'index',
            parts: [
                'IndexDetails',
                {
                    type: 'MinorTabGroupBottom',
                    align: 'center',
                    order: 99
                }
            ],
            order: 101
        },
        indexops: {
            acl: 'g:admin',
            datatype: [
                10
            ],
            tabGroup: 'overview',
            minorTabGroup: 'index',
            parts: [
                'IndexOps',
                {
                    type: 'MinorTabGroupBottom',
                    align: 'center',
                    order: 99
                }
            ],
            order: 102
        },
        indexfacets: {
            acl: 'g:admin',
            datatype: [
                10
            ],
            tabGroup: 'overview',
            minorTabGroup: 'index',
            label: 'Facets',
            parts: [
                'IndexFacets',
                {
                    type: 'MinorTabGroupBottom',
                    align: 'center',
                    order: 99
                }
            ],
            order: 103
        },
        indexsummary: {
            acl: 'g:admin',
            datatype: [
                10
            ],
            tabGroup: 'overview',
            minorTabGroup: 'index',
            label: 'Summary',
            parts: [
                'IndexSummary',
                {
                    type: 'MinorTabGroupBottom',
                    align: 'center',
                    order: 99
                }
            ],
            order: 104
        },
        //~ searchmap: {
        //~ acl: 'g:admin',
        //~ datatype: [1, 2, 0, 10],
        //~ tabGroup: 'titles',
        //~ parts: ['TreeSearchMap'],
        //~ order: 99,
        //~ }
        search: {
            parts: [
                //~ {cssClass: 'noCenterFlex', type: 'GndoQuickSearchPreview'},
                {
                    align: 'center',
                    type: 'SearchResult',
                    filters: [
                        {
                            type: 'getQuickSearchResult',
                            lazy: true
                        }
                    ]
                }
            ]
        }
    }
};
